/*
 * @Date: 2020-08-26 16:39:31
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-09 16:18:37
 * @FilePath: \pc-mall\src\router.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import home from './views/home.vue'
import buyTicket from './views/buyTicket_3.vue'
import checkOrder from './views/checkOrder.vue'
import myOrder from './views/myOrder_2.vue'
import orderDetail from './views/orderDetail_2.vue'
import fillInOrder from './views/fillInOrder_2.vue'
import payOrder from './views/payOrder.vue'
import paySucceed from './views/paySucceed.vue'
import payFailed from './views/payFailed.vue'
import fillInOrderFeery from './views/fillInOrderFeery.vue'
import login from './views/login.vue'
import registered from './views/registered.vue'
import announcementList from './views/announcementList.vue'
import articleDetail from './views/articleDetail.vue'

Vue.use(Router)
const routes1 = new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: home,
    redirect: '/buyTicket',
    children: [
      {
        path: '/',
        name: 'buyTicket',
        component: buyTicket
      }, {
        path: '/myOrder',
        name: 'myOrder',
        component: myOrder
      }, {
        path: '/fillInOrder',
        name: 'fillInOrder',
        component: fillInOrder
      }, {
        path: '/payOrder',
        name: 'payOrder',
        component: payOrder
      }, {
        path: '/paySucceed',
        name: 'paySucceed',
        component: paySucceed
      }, {
        path: '/checkOrder',
        name: 'checkOrder',
        component: checkOrder
      }, {
        path: '/orderDetail',
        name: 'orderDetail',
        component: orderDetail
      }, {
        path: '/fillInOrderFeery',
        name: 'fillInOrderFeery',
        component: fillInOrderFeery
      }, {
        path: '/payFailed',
        name: 'payFailed',
        component: payFailed
      }, {
        path: '/login',
        name: 'login',
        component: login
      }, {
        path: '/registered',
        name: 'registered',
        component: registered
      }, {
        path: '/announcementList',
        name: 'announcementList',
        component: announcementList
      }, {
        path: '/articleDetail',
        name: 'articleDetail',
        component: articleDetail
      }
    ]
  }
  ]
})
// 路由跳转
var _hmt = _hmt || []
window._hmt = _hmt // 必须把_hmt挂载到window下，否则找不到
routes1.beforeEach((to, from, next) => {
  // 统计代码
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', to.fullPath])
    }
  }
  next()
})
export default routes1
